module.exports = __webpack_public_path__ + "img/Feature.c70c19e2.jpg";